import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { PostFolder } from '../../../../../../../types/postFolders';
import { HomeOutlined, FolderOutlined } from '@ant-design/icons';
import './style.css';

interface SpaceBreadcrumbProps {
  accountId: string;
  spaceName: string;
  folderPath: PostFolder[];
  onFolderClick: (folder: PostFolder | null) => void;
}

const SpaceBreadcrumb: React.FC<SpaceBreadcrumbProps> = ({
  accountId,
  spaceName,
  folderPath,
  onFolderClick,
}) => {
  const isCurrentFolder = (folder: PostFolder | null): boolean => {
    if (!folder) {
      return folderPath.length === 0;
    }
    return folder.id === folderPath[folderPath.length - 1]?.id;
  };

  return (
    <div className="space-breadcrumb">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to={`/account/${accountId}`}>
            <HomeOutlined /> {accountId}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/account/${accountId}`}>spaces</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a 
            onClick={() => onFolderClick(null)} 
            className={`breadcrumb-link ${isCurrentFolder(null) ? 'current' : ''}`}
          >
            <FolderOutlined /> {spaceName}
          </a>
        </Breadcrumb.Item>
        {folderPath.map((folder, index) => (
          <Breadcrumb.Item key={folder.id}>
            <a 
              onClick={() => onFolderClick(folder)} 
              className={`breadcrumb-link ${isCurrentFolder(folder) ? 'current' : ''}`}
            >
              <FolderOutlined /> {folder.name}
            </a>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default SpaceBreadcrumb; 